<div id="meetings" class="watermark">
  <div class="container-fluid px-lg-5">
    <div class="row">
      <div class="col-12">
        <h2 class="title">IQAC Meetings</h2>

        <div class="ranked mt-4">
          <table class="table table-bordered table-hover align-middle text-center">
            <thead class="table-light">
              <tr>
                <th scope="col">S.No</th>
                <th scope="col">Session</th>
                <th scope="col">Name of File</th>
                <th scope="col">View</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>2024–25</td>
                <td>IQAC Meetings 2024–25</td>
                <td>
                  <a href="/assets/pdf/iqac/IQAC Meetings 2024-25.pdf" target="_blank">
                    <i class="fa-regular fa-eye"></i>
                  </a>
                </td>
              </tr>
              <tr>
                <td>2</td>
                <td>2023–24</td>
                <td>IQAC Meetings 2023–24</td>
                <td>
                  <a href="/assets/pdf/iqac/IQAC meeting 23-24.pdf" target="_blank">
                    <i class="fa-regular fa-eye"></i>
                  </a>
                </td>
              </tr>
              <tr>
                <td>3</td>
                <td>2022–23</td>
                <td>IQAC Meetings 2022–23</td>
                <td>
                  <a href="/assets/pdf/iqac/Meeting2-IQAC-2022-23.pdf" target="_blank">
                    <i class="fa-regular fa-eye"></i>
                  </a>
                </td>
              </tr>
              <tr>
                <td>4</td>
                <td>2021–22</td>
                <td>IQAC Meetings 2021–22</td>
                <td>
                  <a href="/assets/pdf/iqac/IQAC-meetings-21-22.pdf" target="_blank">
                    <i class="fa-regular fa-eye"></i>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>
  </div>
</div>